import { useQuery } from 'react-query';

import { getArticleSuggestedAiPrompt } from '@utils/backend-api/suggestedAiPrompts';

export const suggested_ai_prompt_for_articleS_KEY = 'suggested_ai_prompt_for_articleS';

export function useArticleSuggestedAiPrompts() {
  const { data, isLoading } = useQuery([suggested_ai_prompt_for_articleS_KEY], async () => {
    return await getArticleSuggestedAiPrompt();
  });

  return {
    articleSuggestedAiPrompt: data?.suggestedAiPrompt || null,
    isLoadingArticleSuggestedAiPrompt: isLoading,
  };
}
